/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ProtectedAzureWorkloadsStore } from '../stores/ProtectedAzureWorkloadsStore';

export const ProtectedAzureWorkloadsContext = createContext<ProtectedAzureWorkloadsStore>({} as ProtectedAzureWorkloadsStore);
